import { OcRoleFilterSubtypeHeaderView } from "./role-filter-subtype-header-view";
import { useOcRoleFilterSubtypeHeader } from "./use-role-filter-subtype-header";
import { OcRoleFilterItemData } from "oc/components/role-filter";
import { RoleFilterInput } from "oc/types";

interface OcRoleFilterSubtypeHeaderProps {
  opened: boolean;
  type: keyof RoleFilterInput;
  handleOpen: () => void;
  selectedItems: OcRoleFilterItemData[];
  disabled?: boolean;
}

export const OcRoleFilterSubtypeHeader: React.FC<
  OcRoleFilterSubtypeHeaderProps
> = ({ opened, type, handleOpen, selectedItems, disabled }) => {
  const extraProps = useOcRoleFilterSubtypeHeader({
    selectedItems,
    type,
  });

  return (
    <OcRoleFilterSubtypeHeaderView
      {...extraProps}
      type={type}
      opened={opened}
      handleOpen={handleOpen}
      disabled={disabled}
    />
  );
};
